"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import { useLocale } from "@repo/design-system/hooks/use-locale";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";

// get the kununu link based on the company name, subclient doesn't work for EDT
const kununuLinks = {
  default: "https://www.kununu.com/de/eon",
  "E.ON Grid Solutions GmbH": "https://www.kununu.com/de/eon-grid-solutions",
  "E.ON Digital Technology GmbH": "https://www.kununu.com/de/eon-digital-technology"
};
export default function KununuBox(t0) {
  const $ = _c(18);
  const {
    job
  } = t0;
  const t = useLanguage();
  const locale = useLocale();
  const kununuLink = kununuLinks[job.data.company as keyof typeof kununuLinks] || kununuLinks.default;
  if (job.data.locations.every(_temp)) {
    return null;
  }
  let t1;
  if ($[0] !== t.jobad_exp_kununu_title) {
    t1 = <p className="mb-2 font-medium text-xl">{t.jobad_exp_kununu_title}</p>;
    $[0] = t.jobad_exp_kununu_title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t.jobad_exp_kununu_body) {
    t2 = <p>{t.jobad_exp_kununu_body}</p>;
    $[2] = t.jobad_exp_kununu_body;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CustomImage alt="Kununu Badge" height={790} src="images/jobad/eon/kununu_TopCompanyBadge_2026.webp" width={600} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== kununuLink) {
    t5 = <CustomLink blank={true} href={kununuLink}>{t4}</CustomLink>;
    $[8] = kununuLink;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = locale === "de" ? "images/jobad/eon/Pride_award_de.webp" : "images/jobad/eon/Pride_award_en.webp";
  let t7;
  if ($[10] !== t6) {
    t7 = <div><CustomImage alt="Pride Award" height={790} src={t6} width={600} /></div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t5 || $[13] !== t7) {
    t8 = <div className="mx-auto flex gap-4 sm:w-1/2 lg:w-full">{t5}{t7}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t3 || $[16] !== t8) {
    t9 = <div className="flex flex-col gap-4 py-8 print:hidden">{t3}{t8}</div>;
    $[15] = t3;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
}
function _temp(l) {
  return l.countryCode === "RO";
}